import styled, { keyframes } from 'styled-components';

export const GrowthTrackerSection = styled.div`
  background-color: #8ccea5;
  padding: 40px 20px;
  margin: ${(props) => props.margin};

  @media (max-width: 720px) {
    padding: 26px 12px;
    margin-top: ${(props) => props.mediamargin};
  }
`;

export const GrowthWeeks = styled.ul`
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  position: relative;
  width: 100%;
  max-width: 1260px;
  margin: auto;

  .rightArrow {
    position: absolute;
    background: hsl(0deg, 0%, 100%, 20%);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    left: 0;
    top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transform: rotate(90deg);

    img {
      transform: rotate(90deg);
      width: 10px;
      height: 10px;
    }
    @media (max-width: 720px) {
      cursor: auto;
      top: 0;
    }
  }

  .leftArrow {
    position: absolute;
    background: hsl(0deg, 0%, 100%, 20%);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    right: 0;
    top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 10px;
      height: 10px;
    }
    @media (max-width: 720px) {
      cursor: auto;
      top: 0;
    }
  }
`;

export const GrowthWeekList = styled.li`
  background: rgb(255 255 255 / 20%);
  color: #fff;
  padding: 16px 20px;
  border-radius: 6px;
  font-weight: 500;
  font-size: clamp(16px, 2vw, 22px);
  cursor: pointer;

  @media (max-width: 720px) {
    display: none;
    cursor: auto;
  }

  &.active {
    background: transparent;
    padding: 6px 16px 0px;
    font-size: clamp(16px, 2vw, 24px);

    @media (max-width: 720px) {
      display: block;
    }
  }
  &.show {
    visibility: visible;
  }
  &.hide {
    visibility: hidden;
  }

  & .currentWeek {
    font-size: 10px;
    text-align: center;
  }
`;
export const CurrentWeekDiv = styled.span`
  background: transparent;
  color: #fff;
  padding: 2px 20px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: clamp(16px, 2vw, 24px);
  cursor: pointer;
  font-size: 10px;
  text-align: center;

  @media (max-width: 720px) {
    cursor: auto;
  }
`;
export const GrowthWeekDiv = styled.div`
  text-align: center;
`;

export const IdealBabySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  .babyImageSection {
    background: hsl(0deg, 0%, 100%, 0.64);
    border-radius: 50%;
    margin: 16px 18px;
    width: 100%;
    max-width: 280px;
    display: none;
    order: 1;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      margin: auto;
    }
    @media (max-width: 720px) {
      display: block;
      order: 2;
      padding-top: 60%;
    }
  }
`;

const babyrotate = keyframes`
    from {
            transform: rotate(0deg);
    }
    to {
            transform: rotate(359deg);
    }
`;

export const BabySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  margin-left: 0px;
  @media (max-width: 720px) {
    display: block;
    flex: none;
    margin-left: 15px;
  }
  .babyImage {
    background: hsl(0deg, 0%, 100%, 0.64);
    border-radius: 50%;
    margin: 16px 26px;
    width: 100%;
    max-width: 280px;
    order: 1;
    display: block;

    img {
      width: 100%;
      height: auto;
      animation: ${babyrotate} 60s infinite linear;
    }
    @media (max-width: 720px) {
      display: none;
      order: 2;
    }
  }
`;

export const BabySizeSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 720px) {
    align-items: flex-start;
  }
`;

export const IdealMeasurmentHeight = styled.div`
  text-align: center;
  color: hsl(0deg, 0%, 100%);
  .whiteOpacity {
    color: hsl(0deg, 0%, 100%, 73%);

    padding-bottom: 4px;
    font-size: clamp(16px, 2vw, 20px);
  }
  & p {
    padding: 7px 0px;
  }
  .normal {
    text-decoration: none;
  }

  @media (max-width: 720px) {
    order: 1;
    text-align: left;
    .normal {
      text-decoration: underline;
      text-underline-offset: 13px;
    }
  }
`;
export const IdealMeasurmentWeight = styled.div`
  text-align: center;
  color: hsl(0deg, 0%, 100%);
  order: 2;
  margin-top: 0px;
  .whiteOpacity {
    color: hsl(0deg, 0%, 100%, 73%);

    padding-bottom: 4px;
    font-size: clamp(16px, 2vw, 20px);
  }
  & p {
    padding: 7px 0px;
  }
  @media (max-width: 720px) {
    margin-top: 10px;
    order: 1;
    text-align: left;
  }
`;

export const BabyFruitSize = styled.div`
  width: clamp(60px, 9vw, 110px);
  height: clamp(60px, 9vw, 110px);
  border-radius: 8px;
  background: hsl(0deg, 0%, 100%, 36%);
  padding: 10px;
  display: flex;
  img {
    width: 100%;
    min-width: 40px;
    height: 100%;
    margin: auto;
  }
`;

export const BabyDetail = styled.div`
  margin: 0 0 0 30px;
  color: #fff;

  @media (max-width: 720px) {
    margin: 0 16px 0 16px;
  }

  .size {
    font-size: clamp(12px, 2vw, 22px);
  }
  .babyLine {
    width: 44ch;
    // display: -webkit-box;
    // -webkit-line-clamp: 4;
    // -webkit-box-orient: vertical;
    // overflow: hidden;
    font-size: clamp(12px, 2vw, 14px);
    @media (max-width: 720px) {
      width: 100%;
    }
  }
  p {
    margin: 0 0 10px;
  }
`;

export const ReadmoreweekCTA = styled.a`
  background: rgb(0 0 0 / 40%);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 21px;
  padding: 12px 0;
  color: #fff;
  font-weight: 500;
  font-size: clamp(15px, 2vw, 18px);
  margin-top: 6px;

  img {
    margin-left: 4px;
    width: 12px;
    height: 12px;
  }
`;
